import { ActionProcessMode } from '@infotech-soe/metaschema';

import { ClientContext } from '../../context/IContextService';
import UniqueId from '../../uid/UniqueId';
import { CommandName } from '../CommandViewModel';
import { getLastReportCode } from '../reportSelectionCache';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommandImpl from './CategoryCommandImpl';

export { getLastReportCode, rememberLastReport } from '../reportSelectionCache';

export const REPORTS_SELECT_ACTION = '__reports_select__';

class ReportsCommandImpl extends CategoryCommandImpl<Record<string, any>> {
  constructor(private datasetId: UniqueId) {
    super();
  }

  public async execute(): Promise<void> {
    return;
  }

  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.SHOW_CATEGORY,
      category: 'Utils',
      displayMode: 'reports',
      action: REPORTS_SELECT_ACTION,
      dataset: this.datasetId,
      multiSelect: false,
      hideTree: true,
      fullHierarchy: true,
      hideCheckbox: true,
      nextAction: REPORTS_SELECT_ACTION,
    };
  }

  public async getInitialArgs(
    context: ClientContext
  ): Promise<Record<string, any>> {
    const category = context.get('Category');
    const displayMode = context.get('DisplayMode');
    const lastReportCode = getLastReportCode(category, displayMode);
    return {
      inParams: {
        category,
        displayMode,
        // eslint-disable-next-line camelcase
        pos_code: lastReportCode,
      },
    };
  }

  public getName(): CommandName {
    return 'reports';
  }

  public getProcessMode(): ActionProcessMode {
    return 'Any';
  }
}

export default ReportsCommandImpl;
